import { render, staticRenderFns } from "./YearPlan.vue?vue&type=template&id=5916fc2c&scoped=true"
import script from "./YearPlan.vue?vue&type=script&lang=js"
export * from "./YearPlan.vue?vue&type=script&lang=js"
import style0 from "./YearPlan.vue?vue&type=style&index=0&id=5916fc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916fc2c",
  null
  
)

export default component.exports